export const convertQuarterDateToString = (date: string) => {
  const splitDate = date.split('-')
  if (splitDate.length === 2) {
    const [year, quarter] = splitDate
    return `${year}-Q${quarter}`
  }
  return date
}
